import { Injectable } from "@angular/core";
import { BreeceApiService } from "../breece-api.service";
import { Observable, of } from "rxjs";
import { ITableFilterSetState } from "../../../state/table-state/interfaces/table-filter-set.sate";

@Injectable({
    providedIn: 'root'
})
export class FilterSetApiService extends BreeceApiService {

    getFilterSets(): Observable<ITableFilterSetState[]>{
        return of([]);
    }

}